<div
    class="h-full w-[22vw] rounded-tl-xl py-2 bg-base-100 text-base-content overflow-y-auto overflow-x-hidden transition-all flex flex-col"
    [ngClass]="{ '!w-12': !expanded }"
>
    <div class="w-full flex flex-col h-full">
        <button class="ml-2 btn btn-sm btn-ghost btn-circle text-primary" (click)="expanded = !expanded">
            <iota-icon icon="chevron-double-right" *ngIf="expanded"></iota-icon>
            <iota-icon icon="chevron-double-left" *ngIf="!expanded"></iota-icon>
        </button>

        <div [ngClass]="{ invisible: !expanded }" class="px-5">
            <ng-container [ngTemplateOutlet]="upperContentTemplate"></ng-container>
        </div>

        <ng-template #menuTemplate let-entries="entries">
            <ng-container *ngFor="let menuEntry of entries">
                <ng-container *ngIf="!menuEntry?.hidden && menuEntry?.children">
                    <li
                        class="bg-inherit mt-5 uppercase font-bold text-iota-sidebar-category pl-4 ml-4 cursor-default"
                        [ngClass]="{ invisible: !expanded }"
                    >
                        <span class="bg-inherit py-[1px] cursor-default" *ngIf="menuEntry?.label">{{ menuEntry?.label }}</span>
                    </li>
                    <ng-container *ngFor="let child of menuEntry?.children">
                        <li *ngIf="!child?.hidden">
                            <a
                                [routerLink]="child?.route"
                                [routerLinkActive]="['!text-primary']"
                                class="!px-0 py-[1px] bg-inherit text-black flex items-center gap-3 mt-2 fill-black"
                                (click)="handleClick($event, child)"
                                [matTooltip]="child?.label"
                                [matTooltipDisabled]="expanded"
                                matTooltipPosition="left"
                                matTooltipClass="bg-iota-tooltip-bg"
                            >
                                <div class="flex">
                                    <iota-icon *ngIf="!!child?.heroicon" [icon]="child?.heroicon" class="stroke-[2]" size="1.25">
                                    </iota-icon>
                                    <iota-icon *ngIf="!!child?.flaticon" [flaticon]="child?.flaticon" class="stroke-[2]" size="1.25">
                                    </iota-icon>
                                </div>
                                <span class="text-[16px]" [ngClass]="{ invisible: !expanded }">{{ child?.label }}</span>
                            </a>
                        </li>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-template>

        <div class="flex flex-col flex-grow">
            <ul class="px-4 menu menu-compact" [ngClass]="{ 'px-0': !expanded }">
                <ng-container *ngTemplateOutlet="menuTemplate; context: { entries: menuEntries }"></ng-container>
            </ul>

            <ul class="px-4 menu menu-compact lg:mt-auto" [ngClass]="{ 'px-0': !expanded }">
                <ng-container *ngTemplateOutlet="menuTemplate; context: { entries: bottomMenuEntries }"></ng-container>
            </ul>
        </div>

        <div [ngClass]="{ invisible: !expanded }">
            <ng-container [ngTemplateOutlet]="lowerContentTemplate"></ng-container>
        </div>
    </div>
</div>
